import {ChangeEvent, FC, ReactNode} from 'react';

import {FieldProps} from 'formik';

import {TextField, useTheme} from '@mui/material';

import {getFieldStyle} from '../../layouts/theme/FieldStyles';

interface EmpionTextFieldProps {
  size: 'small' | 'medium';
  startAdornment?: ReactNode;
  endAdornment?: ReactNode;
  sx?: any;
  required?: boolean;
  label?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
}

export const EmpionTextField: FC<EmpionTextFieldProps & FieldProps> = ({
  field,
  size,
  startAdornment,
  endAdornment,
  required,
  label,
  onChange,
  ...props
}) => {
  const theme = useTheme();
  const fieldStyle = getFieldStyle(theme);

  return (
    <TextField
      {...field}
      onChange={onChange ? onChange : field.onChange}
      {...props}
      size={size}
      label={label ? (required ? `${label}*` : `${label}`) : ''}
      sx={{...fieldStyle, ...props.sx}}
      InputProps={{
        startAdornment: startAdornment,
        endAdornment: endAdornment,
      }}
    />
  );
};
